/*
 view_amountselect.js
 */
import actions from '../../common/lib/utils/actions.js';
import core from '../../common/lib/core.js';
import viewTextkeys from '../../commonview/lib/view-textkeys.js';

const create = core.create; // creates basic elements not inserted into the dom
const nodetree = core.nodetree; // inserts an array of elements into a document-fragment which later may be inserted into the dom
const classnameShow = 'notify--is-open'; // 'u-show';
const classnameHide = 'u-hide';
let textkeysObj = {};
let initializedForMethodId;

function createWrap() {
	return create({
		type: 'div',
		class: 'view-amountselect__wrap deposit-siru notify'
	});
}

function createHeadline(type = 'h2', txt = 'some text') {
	const elm = create({
		type,
		class: 'notify__main-title'
	});
	elm.innerHTML = txt;
	return elm;
}

function createText(type = 'p', txt = 'some text') {
	const elm = create({
		type,
		class: 'notify__p'
	});
	elm.innerHTML = txt;
	return elm;
}

function createCloseButton(eventFilter = '', txt = 'close') {
	const cName = `${eventFilter} btn btn--secondary u-b-radius-bottom`;
	const elm = create({
		type: 'button',
		class: cName,
		value: 'close'
	});
	elm.innerHTML = txt;
	return elm;
}

function createOptions(p) {
	// args: p.obj, p.keytoval, p.keytotext, p.selectedId
	const eventFilter = (p.eventFilter || '');
	const cName = `js-the-label ${eventFilter} filters__filter u-text-c u-cursor-hand grid-u-sm-1-4`;
	const amounts = p.amounts;
	const keytoval = p.keytoval;
	const keytotext = p.keytotext;
	const selectedId = (p.selectedId || null);
	const nodes = [];
	const elmRef = {};
	const labelsRef = {};
	Object.keys(amounts).forEach((index) => {
		/* A reference to the element is saved. */
		const value = ((amounts[index] && amounts[index][keytoval]) || (`${keytoval} missing`));
		const id = `f-${value}`;
		const elm = create({
			type: 'input',
			'input-type': 'radio',
			id,
			class: 'js-the-input',
			name: 'siru-predetermined-deposit-amounts',
			value: ((amounts[index] && amounts[index][keytoval]) || (`${keytoval} missing`))
		});
		const elm2 = create({
			type: 'label',
			for: id,
			class: cName
		});
		elm2.innerHTML = ((amounts[index] && amounts[index][keytotext]) || (`${keytoval} missing`));
		if ((selectedId || selectedId === 0) && (amounts[index].id || amounts[index].id === 0)) {
			if (amounts[index].id && amounts[index].id === selectedId) {
				elm.checked = 'checked';
			}
		}
		/* The uninserted nodes are returned as a list to be inserted with 'nodetree'-function. */
		elmRef[id] = elm;
		labelsRef[id] = elm2;
		nodes.push(elm, elm2);
	});
	/* to evaluate the input-elements with information from the label-elements, a reference
	is stored to each input, sorted on its 'id'. */
	return {
		nodes,
		elmRef,
		labelsRef
	};
}

function mainHandler(e, onEventCb, eventFilterSeparatorClassname) {
	const eventFilterSelector = `.${eventFilterSeparatorClassname}`;

	function cb(p) {
		p.e.stopPropagation();
		p.e.preventDefault();
		const labelElm = p.elm;
		const close = Boolean((labelElm && labelElm.value) && labelElm.value === 'close');
		const inputid = labelElm.getAttribute('for');
		onEventCb({
			inputid,
			close
		});
	}
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked */
	core.handle(e, eventFilterSelector, cb, true);
}

function addListeners(elm, cbOnEvent, eventFilter, eventType) {
	function handleCreator(e) {
		mainHandler(e, cbOnEvent, eventFilter);
	}
	core.addListener(elm, eventType, handleCreator);
	return handleCreator;
}

function removeListeners(elm, handler, eventType) {
	if (elm) {
		core.removeListener(elm, eventType, handler);
	}
}

function show(elm) {
	if (elm) {
		core.removeClass(elm, classnameHide);
		core.addClass(elm, classnameShow);
	}
}

function hide(elm) {
	core.removeClass(elm, classnameShow);
	core.addClass(elm, classnameHide);
}

function checkTheAmount(elms, val) {
	elms.forEach((elm) => {
		const elmval = parseInt(elm.value, 10);
		const cVal = parseInt(val, 10);
		if (elmval === cVal) {
			elm.checked = true; // eslint-disable-line no-param-reassign
		}
	});
}

function updateSelection(inputElms, labelElms, amounts) {
	/* elements.inputs, elements.labelsRef, amounts) */
	Object.keys(inputElms).forEach((key, index) => {
		const am = ((amounts[index] && amounts[index].value) || '');
		const txt = ((amounts[index] && amounts[index].text) || '-');
		inputElms[key].value = am; // eslint-disable-line no-param-reassign
		labelElms[key].innerHTML = txt; // eslint-disable-line no-param-reassign
	});
}

export default {
	create() {
		let elements = {};
		const mainEventType = 'click';
		const classNameEventFilter = 'js-eventfilter-viewamountselect';
		textkeysObj = viewTextkeys.depositflow();
		const headlineTxt = textkeysObj['siru-amount-select-headline'];
		const descriptionTxt = textkeysObj['siru-amount-select-description'];
		const buttoncloseText = textkeysObj['verify-amount-selection-button'];
		elements.wrap = (elements.wrap || createWrap());
		elements.subwrap = (elements.subwrap || create('div', 'option-box u-text-c u-b-radius u-pos-c grid-u-sm-3-4'));
		elements.optionbox = (elements.optionbox || create('div', 'option-box__inner u-p1'));
		elements.headline = (elements.headline || createHeadline('h2', headlineTxt));
		elements.shortText = (elements.shortText || createText('p', descriptionTxt));
		elements.wrapOptions = (elements.wrapOptions || create('div', 'user-options'));
		elements.subwrapOptions = (elements.subwrapOptions || create('div', 'filters grid-r u-b-radius'));
		elements.buttonclose = (elements.buttonclose || createCloseButton(classNameEventFilter, buttoncloseText));
		const callbackOnMainEvent = function callbackOnMainEvent(obj) {
			/*
			 * the mainHandler returns the labels 'for'-value, which is used
			 * to read the value from the corresponding input. This is a
			 * workaround to combine styling and default behaviour of input-element.
			 */
			const inputElm = ((obj.inputid && elements.inputs) ? elements.inputs[obj.inputid] : null);
			const value = (inputElm && inputElm.value);
			if (inputElm) {
				/* set this element to checked manually (since the default behaviour is blocked)*/
				inputElm.checked = true;
			}
			if (obj && obj.close) {
				hide(elements.wrap);
			} else if (obj && !obj.close) {
				actions.viewAmountselect({
					amount: value
				});
			}
		};
		const handler = addListeners(elements.wrap, callbackOnMainEvent, classNameEventFilter, mainEventType);
		elements.wrap.appendChild(elements.subwrap);
		elements.subwrap.appendChild(elements.optionbox);
		elements.subwrap.appendChild(elements.buttonclose);
		elements.optionbox.appendChild(elements.headline);
		elements.optionbox.appendChild(elements.shortText);
		elements.optionbox.appendChild(elements.wrapOptions);
		elements.wrapOptions.appendChild(elements.subwrapOptions);
		return {
			wrap: elements.wrap,
			show() {
				show(elements.wrap);
			},
			hide() {
				hide(elements.wrap);
			},
			update(state) {
				/* this module accepts the format:
				{'name1':[{'value':'some text'}, ... 'nameN':{'value':'some text other'}]}
				 */
				if (state && state.fetch_fees_and_limits) {
					const amounts = state.fetch_fees_and_limits.defaultAmountsFormatted;
					const methodId = state.fetch_fees_and_limits.paymentMethodId;
					const presetIndex = state.fetch_fees_and_limits.presetIndex;
					const feeBasedOn = state.fetch_fees_and_limits.feeBasedOn;
					let elms;
					const optIndex = null;
					if ((initializedForMethodId && initializedForMethodId === methodId)) {
						/* elements.options is created
						 * refreshSelection(elements.options, amounts);
						 */
						updateSelection(elements.inputs, elements.labelsRef, amounts);
						checkTheAmount(elements.options, feeBasedOn);
					} else {
						/* do this once when the method is selected
						 * create options for default amounts
						 */
						initializedForMethodId = methodId;
						if (amounts) {
							// this should only update when a new list of preset amounts is available
							if (elements.options) {
								// update properties of options to follow the amountlist
								updateSelection(elements.inputs, elements.labelsRef, amounts);
							} else {
								elms = createOptions({
									amounts,
									keytoval: 'value',
									keytotext: 'text',
									selectedId: optIndex,
									eventFilter: classNameEventFilter
								});
								elements.options = elms.nodes;
								elements.inputs = elms.elmRef;
								elements.labelsRef = elms.labelsRef;
								elements.subwrapOptions.appendChild(nodetree(elements.options));
							}
							if ((elements && elements.options) && elements.options[presetIndex]) {
								elements.options[presetIndex].checked = true;
							}
						}
					}
				}
			},
			close() {
				/* hide the spinner if the spinner is closed before hidden.
				Otherwise the '.dim' element will remain on the parent */
				removeListeners(elements.wrap, handler, mainEventType);
				elements = core.deleteElementsInObjectExcept(elements, [], 'view_amountselect:248');
			}
		};
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/payment/lib/view-amountselect.js